module.exports = __webpack_public_path__ + "static/media/ClubHouse.555f9263.png";